import {
  EXTERNAL_USER_SET,
  EXTERNAL_USER_UNSET,
  EXTERNAL_USER_SET_REQUESTING,
} from "./constants";
import {
  USER_SEND_PULSE_NOTIFICATION_REQUESTING,
  USER_SEND_PULSE_NOTIFICATION_SUCCESS,
  USER_SEND_PULSE_NOTIFICATION_ERROR,
} from "../user/constants";
import { LOGOUT } from "../login/constants";
import { IExternalProfileReducer } from "./types";

const initialState: IExternalProfileReducer = {
  requesting: false,
  notificationRequesting: false,
  skills: [],
  createdAt: "",
  _id: "",
  email: "",
  // picture: 'https://s3.eu-west-3.amazonaws.com/liife-db/clem-pp',
  picture: "",
  role: "user",
  experience: 0,
  level: 1,
  fullName: "Sans nom",
  firstName: "",
  lastName: "",
  feed: [],
  deviceId: "",
  achievement: {
    firstOfAll: false,
  },
  bestStreak: 0,
  totalDoneActions: 0,
  currentStreak: 0,
  focus: false,
  latestDays: [
    {
      done: false,
    },
    { done: false },
    { done: false },
    { done: false },
    { done: false },
  ],
  historical: [],
  notifications: [],
  team: [],
  categories: {
    leadership: {
      level: 0,
      experience: 0,
    },
    confidence: {
      level: 0,
      experience: 0,
    },
    stress: {
      level: 0,
      experience: 0,
    },
    publicSpeaking: {
      level: 0,
      experience: 0,
    },
    teamSpirit: {
      level: 0,
      experience: 0,
    },
  },
  achievements: {
    first: { name: "first", level: 0 },
    streak: { name: "streak", level: 0 },
    medal: { name: "medal", level: 0 },
    ally: { name: "ally", level: 0 },
    star: { name: "star", level: 0 },
    champion: { name: "champion", level: 0 },
  },
  teamPoints: 0,
};

const reducer = function userReducer(
  state: IExternalProfileReducer = initialState,
  action,
): IExternalProfileReducer {
  switch (action.type) {
    case USER_SEND_PULSE_NOTIFICATION_REQUESTING:
      return { ...state, notificationRequesting: true };

    case USER_SEND_PULSE_NOTIFICATION_SUCCESS:
    case USER_SEND_PULSE_NOTIFICATION_ERROR:
      return { ...state, notificationRequesting: false };

    case EXTERNAL_USER_SET:
      return { ...initialState, ...action.user, requesting: false };

    case EXTERNAL_USER_SET_REQUESTING:
      return { ...initialState, requesting: true };

    case EXTERNAL_USER_UNSET:
    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
